export default {
  computed: {
    visibleServices() {
      if (!this.storeConfig || !this.storeConfig.services) return []
      return this.storeConfig.services
        .filter((service) => service.is_visible)
        .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
    },
    manageCardsIsVisible() {
      return this.displayOptionIsEnabled('display_manage_payments')
    },
    addressesIsVisible() {
      return this.displayOptionIsEnabled('display_addresses_in_profile')
    },
    rewardsIsVisible() {
      return !!this.branding?.display_options?.display_rewards_page
    },
    giftCardsIsVisible() {
      // Needs both the theme flag and a chain that actually supports gift cards
      return !!(this.branding?.display_options?.display_gift_cards_in_profile && this.storeConfig?.gift_card_info)
    },
  },
  methods: {
    // These flags are opt-out: a theme that never declares the key is treated as
    // enabled, only an explicit falsy value hides the feature.
    displayOptionIsEnabled(key) {
      const displayOptions = this.branding?.display_options
      if (!displayOptions) return true
      if (key in displayOptions && !displayOptions[key]) return false
      return true
    },
  },
}
